<p-card
  header="Контрагент"
  [styleClass]="styleClass">
  <div class="formgrid grid">
    <ng-container *ngIf="!contragent">
      <div class="col-5 flex align-items-center justify-content-center">
        <div class="w-full">
          <crm-contragent-auto-complete
            (selectedContragentChange)="contragentSelect($event)"
            class="w-full"
            styleClass="w-full"
            [inputStyle]="{ width: '100%' }"
            [customSearch]="false"
            [withBankDetails]="true"
            placeholder="Выберите контрагента"
            [appendTo]="appendTo"></crm-contragent-auto-complete>
        </div>
      </div>
      <div class="col-2">
        <p-divider layout="vertical">
          <b>ИЛИ</b>
        </p-divider>
      </div>
      <div class="col-5 flex align-items-center justify-content-center">
        <button
          pButton
          label="Создайте нового"
          icon="pi pi-plus"
          class="p-button-success"
          (click)="createContragent()"></button>
      </div>

      <small
        *ngIf="errors"
        class="p-error pl-2">
        {{ errors }}
      </small>
    </ng-container>
    <ng-container *ngIf="contragent && contragent.id">
      <div
        *ngIf="errors"
        class="col-12 mb-2">
        <small class="p-error">
          {{ errors | parseErrorForm }}
        </small>
      </div>
      <div class="lg:col-6 col-12">
        <div class="flex flex-column p-3 h-full border-100 border-round border-1">
          <div>
            <div class="text-400 text-sm uppercase">{{ contragent.personType | personTypeName }}</div>
            <a
              crmConditionalRouterLink
              [routerLink]="['/client/contragent/card/', contragent.id]"
              class="text-lg font-bold">
              {{ contragent.name }}
            </a>
          </div>
        </div>
      </div>
      <div class="lg:col-6 col-12">
        <crm-table
          name="contragent-info"
          styleClass="p-datatable-sm p-datatable-gridlines border-round border-top-1 border-bottom-1 border-100">
          <ng-template #rowTemplate>
            <tr>
              <td class="font-medium">ИНН</td>
              <td>{{ contragent.inn }}</td>
            </tr>
            <tr>
              <td class="font-medium">КПП</td>
              <td>{{ contragent.kpp }}</td>
            </tr>
          </ng-template>
        </crm-table>
      </div>

      <div class="col-12 mt-3">
        <ng-template [ngTemplateOutlet]="formBankDetails"></ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="contragent && !contragent.id">
      <div class="field lg:col-6 col-12">
        <label class="font-medium required-field">Наименование</label>
        <crm-input-text
          [(value)]="contragent.name"
          class="w-full"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>
      <div class="field lg:col-6 col-12">
        <label class="font-medium required-field">Тип</label>
        <crm-single-select
          dataKey="name"
          [options]="personTypes"
          [filter]="false"
          [isTemplateCombined]="true"
          [(selectedItem)]="contragent.personType"
          [styleClass]="errors?.personType ? 'ng-invalid ng-dirty' : ''"
          [class]="errors?.personType ? 'ng-invalid ng-dirty' : ''"
          [appendTo]="appendTo">
          <ng-template
            #itemTemplate
            let-type="item">
            {{ type.value | personTypeName }}
          </ng-template>
        </crm-single-select>
        <small
          *ngIf="errors?.personType"
          class="p-error">
          {{ errors.personType | join }}
        </small>
      </div>
      <div class="field lg:col-6 col-12">
        <label class="font-medium required-field">ИНН</label>
        <crm-inn-auto-complete
          [isError]="$any(errors?.inn)"
          (selectedPersonChange)="selectedPerson($event)"
          [persons]="persons"
          class="w-full"
          styleClass="w-full"
          inputStyleClass="w-full"
          (personSearch)="searchParson($event)"
          [appendTo]="appendTo"></crm-inn-auto-complete>
        <small
          *ngIf="errors?.inn"
          class="p-error">
          {{ errors.inn | join }}
        </small>
      </div>
      <div class="field lg:col-6 col-12">
        <label class="font-medium">КПП</label>
        <crm-input-text
          [(value)]="contragent.kpp"
          class="w-full"
          [isError]="$any(errors?.kpp)"></crm-input-text>
        <small
          *ngIf="errors?.kpp"
          class="p-error">
          {{ errors.kpp | join }}
        </small>
      </div>

      <div class="field col-12">
        <ng-template [ngTemplateOutlet]="formBankDetails"></ng-template>
      </div>

      <ng-container *ngIf="contragent?.personType | personTypeIsNatural">
        <div class="field-checkbox col-12 mb-3">
          <p-checkbox
            [(ngModel)]="passportShow"
            [binary]="true"
            inputId="passportShow"></p-checkbox>
          <label [for]="'passportShow'">Показать паспортные данные</label>
        </div>
        <ng-container *ngIf="passportShow">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Серия</label>
            <crm-input-text
              [(value)]="contragent.passport.serie"
              [isError]="$any(errors?.passport?.serie)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.passport?.serie"
              class="p-error">
              {{ errors.passport.serie | join }}
            </small>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Номер</label>
            <crm-input-text
              [(value)]="contragent.passport.number"
              [isError]="$any(errors?.passport?.number)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.passport?.number"
              class="p-error">
              {{ errors.passport.number | join }}
            </small>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Кем выдан</label>
            <crm-input-text
              [(value)]="contragent.passport.org"
              [isError]="$any(errors?.passport?.org)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.passport?.org"
              class="p-error">
              {{ errors.passport.org | join }}
            </small>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Дата выдачи</label>
            <crm-datepicker
              [(value)]="contragent.passport.date"
              [inputStyleClass]="errors?.passport?.date ? 'ng-invalid ng-dirty' : ''"
              styleClass="w-full"></crm-datepicker>
            <small
              *ngIf="errors?.passport?.date"
              class="p-error">
              {{ errors.passport.date | join }}
            </small>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Код подразделения</label>
            <crm-input-text
              [(value)]="contragent.passport.code"
              [isError]="$any(errors?.passport?.code)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.passport?.code"
              class="p-error">
              {{ errors.passport.code | join }}
            </small>
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Адрес регистрации</label>
            <crm-input-text
              [(value)]="contragent.passport.address"
              [isError]="$any(errors?.passport?.address)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.passport?.address"
              class="p-error">
              {{ errors.passport.address | join }}
            </small>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <div
      *ngIf="contragent && editable"
      class="col-12 mt-3">
      <button
        pButton
        label="Выбрать другого"
        icon="pi pi-arrow-left"
        class="p-button-secondary p-button-text"
        (click)="clearContragent()"></button>
    </div>
  </div>
</p-card>

<ng-template #formBankDetails>
  <label class="font-medium">Расчетные счета</label>
  <crm-table
    *ngIf="contragent.bankDetails?.length"
    name="contragentBankDetails"
    [columns]="columns"
    [values]="contragent.bankDetails"
    styleClass="p-datatable-sm">
    <ng-template
      #rowTemplate
      let-bankDetail="item"
      let-index="rowIndex">
      <tr *ngIf="toBankDetail(bankDetail) as bankDetail">
        <td>
          <p-checkbox
            [(ngModel)]="bankDetail.isSelected"
            [readonly]="bankDetail.isSelected"
            (ngModelChange)="setSelectedBankDetail(bankDetail)"
            [binary]="true"></p-checkbox>
        </td>
        <td>
          <crm-bank-auto-complete
            styleClass="w-full"
            class="w-full"
            [inputStyle]="{ width: '100%' }"
            [(selectedBank)]="bankDetail.bank"
            [banks]="banks"
            [isError]="$any(errors?.bankDetails?.[toNumber(index)]?.bank)"
            appendTo="body"
            (bankSearch)="bankSearch.emit($event)"></crm-bank-auto-complete>
          <small
            *ngIf="errors?.bankDetails?.[toNumber(index)]?.bank"
            class="p-error">
            {{ errors.bankDetails[toNumber(index)].bank | join }}
          </small>
        </td>
        <td>
          <crm-input-text
            [(value)]="bankDetail.checkingAccount"
            [isError]="$any(errors?.bankDetails?.[toNumber(index)]?.checkingAccount)"
            class="w-full"></crm-input-text>
          <small
            *ngIf="errors?.bankDetails?.[toNumber(index)]?.checkingAccount"
            class="p-error">
            {{ errors.bankDetails[toNumber(index)].checkingAccount | join }}
          </small>
        </td>
        <td class="max-w-3rem">
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="deleteBankDetail(bankDetail)"></button>
        </td>
      </tr>
    </ng-template>
  </crm-table>

  <div class="p-3">
    <button
      pButton
      label="Добавить"
      icon="pi pi-plus"
      class="p-button-text"
      (click)="addBankDetail()"></button>
  </div>
</ng-template>
